// extracted by mini-css-extract-plugin
export var deleteModal = "_so-0";